<template>
  <div id="interprets">
    <div class="block-orange"></div>
    <app-navbar></app-navbar>
    <div class="yellowWrap">
      <img v-parallax="0.2" class="img-fluid" src="@/assets/designelements/yellowWrap.png" alt="whiteBallone">
    </div>
    <div class="whiteBalls">
      <img v-parallax="0.1" class="img-fluid" src="@/assets/designelements/whiteBalls.png" alt="whiteBallone">
    </div>
    <div class="container interpretsBlock">
      <h2 class="text-center">{{ "Interprets.label" | staticTranslation }}</h2>
      <div class="row">
        <div class="col-lg-4 no-gutters" v-for="interpret in interprets" v-bind:key="interpret.id">
          <a v-bind:href="'/program/interpret/' + interpret.id">
            <img loading="lazy" class="img-fluid cropped-img" :src="getInterpretImgUrl(interpret.id)" alt="Foto"></a>
          <h4>{{ interpret.name | translation }}</h4>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import navbar from "@/components/base/navbar";
import axios from "@/api/axiom-instance";
import footer from "@/components/base/footer";
import config from "@/config";

export default {
  name: "Interprets",
  components: {
    'app-navbar': navbar,
    'app-footer': footer
  },
  data() {
    return {
      interprets: []
    }
  },
  created() {
    this.load()
  },
  methods: {
    load: function () {
      axios
          .get("/interpret/list/extended")
          .then((success) => {
            this.interprets = success.data
          }).catch((failed) => {
        console.log(failed)
      })
    },
    getInterpretImgUrl: function (id) {
      return config.API_URL + "/image/preview?type=interprets&name=" + id
    },
  }
}
</script>

<style scoped>
h1 {
  font-size: 3.5em;
  padding-top: 3em;
  padding-bottom: 50px;
  font-family: "Transcript Pro";
}

h2 {
  font-size: 2.5em;
  padding-top: 3em;
  font-family: "Transcript Pro";
}

h3 {
  font-size: 1.5em;
  padding-top: 1.5em;
  font-family: "Transcript Pro";
}

h4 {
  padding: 6px;
  position: absolute;
  font-family: "Transcript Pro";
  font-size: 1.1em;
  text-align: left;
  background-color: #EAEAEA;
  color: #152326;
  margin-bottom: 0;
  bottom: 0;
}

h5 {
  color: black;
  padding-right: 10px;
  display: inline-block;
  font-family: "Transcript Mono";
}

p {
  font-family: "Transcript Mono";
}

.col-lg-4 {
  padding-left: 0;
  padding-right: 0;
}

.cropped-img {
  height: 300px;
  width: auto;
  object-fit: cover;
}

.block-orange {
  background-color: #ED5B2D;
  position: absolute;
  text-align: end;
  top: 45%;
  right: 0;
  height: 76vh;
  width: 88%;
}

.whiteBalls {
  width: 6%;
  position: absolute;
  top: 25%;
  left: 5%;
}

.yellowWrap {
  width: 12%;
  position: absolute;
  text-align: end;
  right: 3%;
  top: 90vh;
}

.interpretsBlock {
  padding-bottom: 4em;
  min-height: 121vh;
}

#interprets {
  background-color: #FFCE6D;
}

@media (min-width: 1200px) {
  .container {
    max-width: 900px;
  }
}
</style>
